<template>
  <!-- 这个页面直接复制了登录之前的修改密码页面，稍作修改 -->
  <div>
    <div class="card_wraper register_wrap">
      <div class="register_title">
        <span class="title">修改密码</span>
        <!-- <router-link to="/" class="go_login" replace>
          返回登录
        </router-link>-->
      </div>
      <div class="info_wrap">
        <div class="info_input">
          <img src="~assets/img/register/shouji_number.png"
               alt
               class="img_input" />
          <!-- 修改1  禁用了手机输入框  并把禁用之后的背景色改成无
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
          //代号 20231204-1  修改placeholder 去掉上面的两行代码
          -->
          <input type="text"
                 class="input_text"
                 placeholder="请输入主账号"
                 v-model="registerSubmitData.telePhone"
                 disabled
                 style="background:none" />
        </div>

        <div class="info_input">
          <img src="~assets/img/register/shouji_mima.png"
               alt
               class="img_input" />
          <input type="password"
                 class="input_text"
                 placeholder="请输入密码"
                 v-model="registerSubmitData.Password"
                 autocomplete="new-password"
                 onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" />
          <!-- 禁止输入中文 onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')-->
        </div>

        <div class="info_input">
          <img src="~assets/img/register/shouji_queren.png"
               alt
               class="img_input" />
          <input type="password"
                 class="input_text"
                 placeholder="请再次输入密码"
                 v-model="registerSubmitData.CPassword"
                 autocomplete="new-password"
                 onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" />
        </div>

        <div class="info_input">
          <img src="~assets/img/register/shouji_tuxing.png"
               alt
               class="img_input" />
          <input type="text"
                 class="input_text img_input_check"
                 placeholder="请输入图形验证码(点击图片刷新)"
                 v-model="registerSubmitData.userCheckCode" />
          <img class="Serve_img_check"
               :src="imgBase64"
               @click="imgCheckClick"
               alt />
        </div>

        <div class="info_input">
          <img src="~assets/img/register/shouji_yanzheng.png"
               alt
               class="img_input" />
          <input type="text"
                 class="input_text img_input_check"
                 placeholder="请输入手机验证码"
                 v-model="registerSubmitData.telePhoneCheckCode" />
          <div class="phone_code_btn"
               @click="CodeBtnHandle"
               :class="phoneCode.state ? '' : 'code_btn_prohibit'">
            获取验证码({{ phoneCode.countS }}S)
          </div>
        </div>
      </div>

      <div class="register_btn"
           @click="registerSubmitHandle">确定修改</div>
    </div>
  </div>
</template>

<script>
//公用函数
import {
  countSHandle,
  checkCallphoneCrc,
  checkUserDataChangePassword
} from 'common/beforeLogin/RegisterPage'

export default {
  name: 'MChangePassword',
  components: {},
  data () {
    return {
      registerSubmitData: {
        ////  用户填写的注册数据
        telePhone: '', //手机号
        Password: '', //密码
        CPassword: '', //重复密码
        userCheckCode: '', //用户输入的校验ID
        // cityCode:"", //用户选择的城市ID编号
        telePhoneCheckCode: '', ///用户输入的手机短信验证码
        // checkState:false, ////多选框的选中状态 默认不勾选
        imgCheck: {
          //// 获取的服务端提供的图片验证码的缓存
          Servercode: '',
          ServeBase64Date: '',
          ServeImgUuid: ''
        }
      },
      phoneCode: {
        state: true, ///获取手机验证码的按钮状态
        countS: 60
      }
    }
  },
  computed: {
    imgBase64 () {
      ///图片验证码的BASE64数据
      return (
        'data:image/jpeg;base64,' +
        this.registerSubmitData.imgCheck.ServeBase64Date
      )
    }
  },
  methods: {
    rquestServerImgCheck () {
      ///刷新图片注册验证码接口
      this.$request({
        method: 'post',
        ///请求参数  用户使用协议
        url: '/config/getImageCode'
        // data:{"type":"0"}
      })
        .then(res => {
          ////请求成功的回调
          this.registerSubmitData.imgCheck.Servercode = res.data.data.code ///取数据
          this.registerSubmitData.imgCheck.ServeBase64Date = res.data.data.image //取数据
          this.registerSubmitData.imgCheck.ServeImgUuid = res.data.data.uuid //取数据
          // console.log(res);
          // console.log(this.imgCheck.ServeBase64Date);
        })
        .catch(err => {
          ////失败的回调
          console.log(err)
        })
    },
    imgCheckClick () {
      ///点击图片处理
      this.rquestServerImgCheck()
    },
    CodeBtnHandle () {
      ///获取手机验证码 按钮事件
      if (this.phoneCode.state) {
        ////按钮可点击状态
        if (!checkUserDataChangePassword(this.registerSubmitData)) return ///数据不正确直接退出并提示toast，不再请求接口
        // if(! )
        // 请求服务器接口
        this.$request({
          method: 'post',
          url: '/sms/sendPhoneCode',
          data: {
            uuid: this.registerSubmitData.imgCheck.ServeImgUuid,
            imageCode: this.registerSubmitData.userCheckCode,
            phone: this.registerSubmitData.telePhone,
            type: 2 //短信类型1:注册 2主账号重置密码 3:登录演示页面 4:换绑手机号
          }
        })
          .then(res => {
            console.log(res)
            this.$toast(res.data.message, 5000) ///服务端返回信息提示
            if (res.data.code != 0) {
              ////说明信息填写错误
              return
            } else {
              countSHandle(this.phoneCode) ///说明信息填写成功，成功发送了验证码，屏蔽按钮，开始倒计时
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    registerSubmitHandle () {
      ////点击注册按钮的数据处理
      if (!checkUserDataChangePassword(this.registerSubmitData)) return ///数据不正确直接退出并提示toast，不再请求接口
      if (!checkCallphoneCrc(this.registerSubmitData.telePhoneCheckCode)) return ///手机短信验证码是否填写，没填写直接退出，不再请求接口
      // 请求服务器接口
      this.$request({
        method: 'post',
        url: '/user/resetMainPwd',
        data: {
          phone: this.registerSubmitData.telePhone,
          newPwd: this.registerSubmitData.Password,
          code: this.registerSubmitData.telePhoneCheckCode
        }
      })
        .then(res => {
          console.log(res)
          this.$toast(res.data.message, 5000) ///服务端返回信息

          if (res.data.code != 0) {
            ////说明信息填写错误

            return
          } else {
            this.$store.dispatch(
              'asyUpdataLoginAccount',
              this.registerSubmitData.telePhone
            ) ///异步提交用户的账号信息到仓库
            // this.$router.replace('/') ///说明注册成功，返回到登陆页面
            this.$showTipsToast(1, '修改成功', true) ////提示框
            this.configReturnBtnHandle() ////退出登录
          }
        })
        .catch(err => {
          console.log(err)
        })
      // this.$store.dispatch('asyUpdataLoginAccount',this.registerSubmitData.telePhone); ///异步提交用户的账号信息到仓库
      // this.$toast("注册成功！",5000);  ///服务端返回信息
      // this.$router.replace('/'); ///说明注册成功，返回到登陆页面
    },
    configReturnBtnHandle () {
      ////退出登录按钮
      sessionStorage.clear() //清空浏览器缓存token
      this.$store.dispatch('asyUpdataToken', '') ///清空vuex里面的token
      this.$router.replace('/login')
    }
  },
  created () {
    /////
    this.registerSubmitData.telePhone = sessionStorage.getItem('account')
  },
  mounted () {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    this.rquestServerImgCheck() ///请求新的图片验证码
  }
}
</script>

<style>
/* 注册页面 修改密码页面  修改主账号密码页面  修改子账号密码页面共用样式 */
</style>
